const importReportOutcomes = {
	APPLIED: "applied",
	OLDER: "older",
	NOT_DRAFT: "not_draft",
};

export default importReportOutcomes;
